const PHRASES = [
  "La vida es Croc",
  "Crocca sin reglas",
  "Crocca por fuera",
  "Brutal por dentro",
];

const MarqueeContent = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.concat(PHRASES).map((phrase, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <span className="font-display font-semibold uppercase tracking-wide text-sm md:text-base">
          {phrase}
        </span>
        <span className="mx-6 text-white/60" aria-hidden="true">
          ·
        </span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="brand-marquee"
    className="bg-brand-pink text-white py-3 md:py-4 overflow-hidden"
    aria-hidden="true"
  >
    <div className="animate-croc-marquee flex w-max">
      <MarqueeContent />
      <MarqueeContent />
    </div>
  </div>
);

export default Marquee;
